import React, { useState, useEffect, useCallback, useContext } from "react";
import UpgradeModal from "../components/UpgradeModal";
import { useSubscription } from "../../shared/hooks/useSubscription";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from "../../shared/context/auth-context";
import { Button, Modal } from "react-bootstrap";
import "../subscription.css";

/* FIX USAGE OF ORGID */

const TeamManagement = () => {
	const auth = useContext(AuthContext);

	const { subscription, usage, refresh } = useSubscription();
	const { sendRequest } = useHttpClient();

	const [members, setMembers] = useState([]);
	const [showUpgradeModal, setShowUpgradeModal] = useState(false);
	const [selectedMember, setSelectedMember] = useState(null);

	const fetchTeamData = useCallback(async () => {
		try {
			const response = await sendRequest(`/api/users/organization/`, "GET");

			setMembers(response.data);
		} catch (error) {
			console.error("Error fetching team data:", error.message);
		}
	}, [sendRequest]);

	useEffect(() => {
		fetchTeamData();
	}, [fetchTeamData]);

	const grantUserSeat = async (userId) => {
		if (!subscription) {
			alert("No active subscription found");
			return;
		}
		try {
			await sendRequest(
				`/api/subscriptions/grant-seat`,
				"POST",
				JSON.stringify({ userId }),
				{
					"Content-Type": "application/json",
					Authorization: `Bearer ${auth.token}`,
					//"X-Org-Id": orgId,
				}
			);
			alert("Seat granted successfully!");
			setSelectedMember(null);
			await refresh();
			await fetchTeamData();
		} catch (error) {
			alert("Error granting seat: " + (error.message || "Unknown error"));
		}
	};

	const removeUserSeat = async (userId) => {
		if (!subscription) {
			alert("No active subscription found");
			return;
		}
		try {
			await sendRequest(
				`/api/subscriptions/remove-seat`,
				"DELETE",
				JSON.stringify({ userId }),
				{
					"Content-Type": "application/json",
					Authorization: `Bearer ${auth.token}`,
				}
			);
			alert("Seat removed successfully!");
			setSelectedMember(null);
			await refresh();
			await fetchTeamData();
		} catch (error) {
			alert("Error granting seat: " + (error.message || "Unknown error"));
		}
	};

	return (
		<div className="team-management">
			<div className="team-header">
				<h2>Team Management</h2>
				{subscription && (
					<div className="seat-usage">
						<span
							className={`usage ${
								usage?.usedSeats >= usage?.allowedSeats ? "at-limit" : ""
							}`}
						>
							{`${usage?.usedSeats || 0}/${
								usage?.allowedSeats || 0
							} seats used`}
						</span>
					</div>
				)}
			</div>

			<div className="members-list">
				<h3>Current Members</h3>
				<div className="members">
					{members.map((member) => (
						<div
							key={member.id}
							className="member-card"
							onClick={() => setSelectedMember(member)}
						>
							<div className="member-info">
								<div className="member-name">{`${member.firstName} ${member.lastName}`}</div>
								<div className="member-email">{member.email}</div>
							</div>
							<div className="member-role">
								{(member.expiry && member.role !== "owner") ? (
									<span className={`role-badge hasSeat`}>
										{member.role} with Seat
									</span>
								) : (
									<span className={`role-badge ${member.role}`}>
										{member.role}
									</span>
								)}
							</div>
						</div>
					))}
				</div>
			</div>

			{selectedMember && (
				<MemberModal
					member={selectedMember}
					grantUserSeat={grantUserSeat}
					removeUserSeat={removeUserSeat}
					onClose={() => setSelectedMember(null)}
				/>
			)}

			{showUpgradeModal && (
				<UpgradeModal
					currentSeats={subscription?.seats || 0}
					onClose={() => setShowUpgradeModal(false)}
					onUpgrade={fetchTeamData}
				/>
			)}
		</div>
	);
};

export default TeamManagement;

const MemberModal = ({ member, grantUserSeat, removeUserSeat, onClose }) => {
	return (
		<Modal show={true} onHide={onClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>Member Details</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>
					<strong>Name:</strong> {`${member.firstName} ${member.lastName}`}
				</p>
				<p>
					<strong>Email:</strong> {member.email}
				</p>
				<p>
					<strong>Role:</strong> {member.role}
				</p>
				<p>
					<strong>Status:</strong> {member.expiry ? "Active" : "Inactive"}
				</p>
				<p>
					<strong>ID:</strong> {member.uid || "N/A"}
				</p>
				{!member.expiry ? (
					<Button variant="primary" onClick={() => grantUserSeat(member.uid)}>
						Grant Seat
					</Button>
				) : (
					<Button
						variant="secondary"
						onClick={() => removeUserSeat(member.uid)}
					>
						Remove Seat
					</Button>
				)}
			</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={onClose}>
					Close
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
